import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';
import { Divider } from 'primereact/divider';
import Loader from '../../common/LoaderComponent';

interface WeekStatsProps {
    isLoading: boolean;
    weekStats: {
        week: {
            worked: number;
            total: number;
        };
        month: {
            worked: number;
            total: number;
        };
    } | undefined;
}

const WeekStats: React.FC<WeekStatsProps> = ({ isLoading, weekStats }) => {
    const { t } = useTranslation();

    if (isLoading || !weekStats) {
        return <Loader />;
    }

    return (
        <div className="flex justify-center items-center w-full">
            <div className="flex min-w-44 flex-col">
                <div>
                    {t('shiftAssignmentPage.weekStats')}
                </div>
                <div className="flex justify-center items-center gap-2">
                    <div className="flex-grow">
                        <ProgressBar 
                            value={weekStats.week.worked / weekStats.week.total * 100}
                            showValue={false} 
                            className="progress-bar"
                            color="cyan-500" 
                        />
                    </div>
                    <div className="min-w-10 text-right text-2xl">
                        {weekStats.week.total.toFixed(0)}h
                    </div>
                </div>
            </div>
            <div className="px-4">
                <Divider layout="vertical" color="whitesmoke" />
            </div>
            <div className="flex-grow justify-center items-center">
                <div className="flex justify-center items-center">
                    <div className="flex-grow justify-center items-center">
                        {t('shiftAssignmentPage.monthStats')}
                    </div>
                    <div className="min-w-20">
                        {t('shiftAssignmentPage.monthStatsTotal')}
                    </div>
                </div>
                <div className="flex justify-center items-center gap-2">
                    <div className="flex-grow">
                        <ProgressBar 
                            value={weekStats.month.worked / weekStats.month.total * 100}
                            showValue={false} 
                            className="progress-bar"
                            color="cyan-500" 
                        />
                    </div>
                    <div className="min-w-20 text-right text-2xl">
                        {weekStats.month.total.toFixed(0)}h
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeekStats; 